import React, { useState } from 'react';
import './App.css';
import { Canvas } from '@react-three/fiber';

import Model from "./components/model/Model";
import VideoPlane from "./components/model/VideoPlane";

import CameraController from "./components/camera/CameraController";

import GlowingText from "./components/model/GlowingText";

import LoadingScreen from "./components/loading/Loading";

import Modal from "./components/modal/Modal";
import LiftContent from "./components/content/lift/LiftContent";
import CovidContent from "./components/content/covid/CovidContent";
import CsContent from "./components/content/cs/CsContent";
import SocialContent from "./components/content/social/SocialContent";
import Contact from "./components/content/contact/Contact";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [modelsLoaded, setModelsLoaded] = useState([false, false, false, false, false]); // Track the loading state of each model
  const [modalContent, setModalContent] = useState(null);

  const handleModelLoaded = (index) => {
    setModelsLoaded((prev) => {
      const newState = [...prev];
      newState[index] = true;
      if (index === 0) setIsLoading(false); // Update loading state when main model loads
      return newState;
    });
  };

  const openModal = (content) => {
    setModalContent(content);
  };

  const closeModal = () => {
    setModalContent(null);
  };

  return (
    <div className="App">
      {isLoading && (<LoadingScreen />)}

      {modalContent && <Modal content={modalContent} onClose={closeModal} />}

      <Canvas camera={{ position: [0, 1.45, 1.2], fov: 45 }} >
        <directionalLight color={0x0000FF} position={[5, 5, 5]} intensity={.35}/>

        {/* Main model */}
        <Model 
          modelPath="./pc.glb"
          position={[.4, .5, 0.65]}
          scale={[1, 1, 1]}
          rotation={[0, 0, 0]}
          onLoadComplete={() => handleModelLoaded(0)}
          isMain={true}
        />

        {!isLoading && (<VideoPlane position={[-.032, 1.55, 0.45]} scale={[.152, .165, .138]} rotation={[-Math.PI / 17.8, 0, 0]}/>)}

        {/* Additional models with their own positions and scales */}
          <GlowingText 
            position={[-.04, 1.25, 0.53]} 
            size={.035}
            onClick={() => openModal(<CsContent />)}
          />

          <Model 
            modelPath="./mail.glb"
            position={[-.37, 1.18, 0.63]}
            scale={[.01, .01, .01]}
            rotation={[0, Math.PI / 3.5, 0]}
            onLoadComplete={() => handleModelLoaded(1)}
            onClick={() => openModal(<Contact />)}
          />
       
          <Model 
            modelPath="./forklift.glb"
            position={[.4, 1.23, 0.68]}
            scale={[.05, .05, .05]}
            rotation={[0, -Math.PI / 1.5, 0]}
            onLoadComplete={() => handleModelLoaded(2)}
            onClick={() => openModal(<LiftContent />)}
          />
        
          <Model 
            modelPath="./sanitizer.glb"
            position={[.32, 1.27, 0.55]}
            scale={[.01, .01, .01]}
            rotation={[0, -Math.PI / 2, 0]}
            onLoadComplete={() => handleModelLoaded(3)}
            onClick={() => openModal(<CovidContent />)}
          />
       
          <Model 
            modelPath="./heart.glb"
            position={[-.2, 1.235, .65]}
            scale={[.008, .008, .008]}
            rotation={[-Math.PI / 4, Math.PI / 8, Math.PI / 8]}
            onLoadComplete={() => handleModelLoaded(4)}
            onClick={() => openModal(<SocialContent />)}
          />

        <CameraController />
      </Canvas>
    </div>
  );
}

export default App;
